export type AlertCollapsible = {
  id: string;
  type: string;
  related_entity_id?: string | null;
  title?: string;
  created_at?: string;
};

/**
 * Una alerta de inventario bajo por SKU/producto. Conserva la más reciente
 * (la lista suele venir ordenada por created_at desc).
 */
export function collapseInventarioBajoAlerts<T extends AlertCollapsible>(alerts: T[]): T[] {
  const seen = new Set<string>();
  const out: T[] = [];
  for (const a of alerts) {
    if (a.type !== 'inventario_bajo') {
      out.push(a);
      continue;
    }
    const key = String(a.related_entity_id || a.title || '').trim() || `id:${a.id}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(a);
  }
  return out;
}
